module.exports = __webpack_public_path__ + "media/categories/1101-87e3bd75.svg";